module.exports = __webpack_public_path__ + "static/img/image-box4.76ae188e.jpg";